<template>
  <div class="user-list">
    <el-table :data="listData" v-loading="loading" show-summary>
      <el-table-column prop="rule" label="等级">
      </el-table-column>
      <el-table-column prop="count" label="人数">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import {
  server,
  getApiData,
  patchData,
  postApiData,
  patchApiData
} from '../../http'
import {
  getCookie
} from '@/utils/cookie'

export default {
  data() {
    return {
      webUrl: window.location.host,//当前网站域名地址
      listData: [],
      loading: false,
    }
  },
  computed: {
  },
  methods: {
    getUserScoreRuleStatList() {
      this.loading = true
      getApiData(`get_user_score_rule_stat_list`, {})
        .then(res => {
          this.loading = false
          if (res) {
            this.listData = res
          }
        }).finally(() => {
        this.loading = false
      })
    },
  },
  created() {
    this.getUserScoreRuleStatList();
  }
}

</script>
<style lang="less" scoped>

</style>
